import React, { useEffect, useRef, useState } from "react";

import { StickyBarBlock as Value } from "@reactivated";

import { ButtonPrimary } from "../Clickables";

import styles from "./StickyBar.module.scss";

interface StickyBarProps {
    value: Value;
}

export const StickyBar = ({ value }: StickyBarProps) => {
    const sentinelRef = useRef<HTMLDivElement>(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            (entries) => {
                for (const entry of entries) {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    } else if (entry.boundingClientRect.top > 0) {
                        setIsVisible(false);
                    } else {
                        setIsVisible(true);
                    }
                }
            },
            {
                root: null,
                threshold: 0,
            },
        );

        observer.observe(sentinel);

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <>
            <div ref={sentinelRef} className={styles.sentinel} />
            <aside className={styles.bar} data-visible={isVisible}>
                <div className={styles.inner}>
                    <p className={styles.text}>{value.text}</p>
                    {value.button && (
                        <ButtonPrimary
                            data-click-type="sticky_cta"
                            simpleLink={value.button}
                        />
                    )}
                </div>
            </aside>
        </>
    );
};
